import React from 'react'

const LogoIcon = () => {
  return (
    <img src={'./images/logo-icon.png'} alt="Aerosim" width="35px" />
  )
}

export default LogoIcon